import Vue from 'vue';
import Vuex from 'vuex';
import api from './api';
Vue.use(Vuex);

const index = new Vuex.Store({
  state: {
    url_1: "https://newsapi.netbank.cn",
    // url_1: "http://10.201.5.189:9090"
    // url_1:"http://example-website22-github-clz.cubepaas.com"
  },
  mutations: {},
  actions: {},
  modules: { api }
});

export default index;



// WEBPACK FOOTER //
// ./src/store/index.js